import { appInsights, setAuthenticatedUser, setUserId, clearUser } from "./appInsights";

interface TelemetryProps {
  [key: string]: any;
}

class TelemetryService {
  setAuthenticatedUser(username: string | null) {
    setAuthenticatedUser(username);
  }

  setUserId(userId: string) {
    setUserId(userId);
  }

  clearUser() {
    clearUser();
  }

  trackEvent(name: string, properties?: TelemetryProps) {
    appInsights.trackEvent({ name, properties });
  }

  trackPageView(name?: string, properties?: TelemetryProps) {
    appInsights.trackPageView({ name, properties });
  }

  trackException(error: Error, properties?: TelemetryProps) {
    appInsights.trackException({ exception: error, properties });
  }

  trackTrace(message: string, properties?: TelemetryProps) {
    appInsights.trackTrace({ message, properties });
  }
}

export const telemetryService = new TelemetryService();
